module.exports = __webpack_public_path__ + "static/media/onboarding.fef62335.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user/onboarding.svg
// module id = 871
// module chunks = 0